/**
 *
 * URL parameters
 *
 * @class UrlParam
 *
 * @author Cedric Hoarau <cedric.hoarau@kabandy.com>
 *
 * @copyright (c) Kabandy 2016-2022. All rights reserved.
 *
 */

import { IUrlParam } from ".";

export class UrlParam {
    constructor() {}

    public static GetInt(url: string, param: string = ""): number | null {
        const urlParam: string | null = UrlParam.Get(url, param);
        return urlParam ? parseInt(urlParam) : null;
    }

    public static Get(url: string = "", param: string = ""): string | null {
        url = url.split("?").pop() || "";
        const urlSearchParams: URLSearchParams = new URLSearchParams(url);
        return urlSearchParams.get(param);
    }

    public static GetAll(url: string = "", param: string = ""): string[] {
        let oParams: string[] = [];

        const paramAsArrayStr: string | null = UrlParam.Get(url, param);
        if (paramAsArrayStr) {
            oParams = paramAsArrayStr.split(",");
        }

        return oParams;
    }

    public static Has(url: string = "", param: string = ""): boolean {
        url = url.split("?").pop() || "";
        const urlSearchParams: URLSearchParams = new URLSearchParams(url);
        return urlSearchParams.has(param);
    }

    public static FormatTargetUrl(hostnameWithProtocol: string = "", urlParams: IUrlParam[] = []) {
        let targetUrl: string = hostnameWithProtocol + "/";

        urlParams.forEach((urlParam: IUrlParam, index: number) => {
            let prefix: string = index > 0 ? "&" : "?";
            targetUrl += prefix + urlParam.key + "=" + urlParam.value;
        });

        return targetUrl;
    }
}
